module.exports = __webpack_public_path__ + "static/media/logo_saigonbank.9bfa6ae5.svg";